module.exports = __webpack_public_path__ + "static/media/Advent2025.3aa626d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Advent2025.jpg
// module id = 330
// module chunks = 0